import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { completeGoogleAuth } from "@actions/auth/completeGoogleAuth";
import { MAIN_PAGE } from "@constants";
import { Spinner } from "@components/library/Spinner";

const GoogleAuthCallback = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      window.location.replace("/");
      return;
    }

    dispatch(completeGoogleAuth(token))
      .then(() => {
        window.location.replace(MAIN_PAGE);
      })
      .catch(() => {
        window.location.replace("/");
      });
  }, [dispatch, searchParams]);

  return <Spinner />;
};

export default GoogleAuthCallback;
